import { mdiImageAlbum } from '@mdi/js'

export default {
  title: 'Slider Admin',
  to: 'slider-admin-list',
  icon: mdiImageAlbum,
  resource: 'SliderSchool',
  action: 'read',
}
